/**
 *  Init carousel for promo banner
 */
const initHeaderCarousel = () => {
    var $headerSlider = $(".header-bar .js-content-carousel");
    var speed = $headerSlider.data("speed") ? $headerSlider.data("speed") : "3000";

    if ($headerSlider.length && $headerSlider.children().length > 1) {
        $headerSlider.slick({
            prevArrow: `<button type="button" class="slick-prev-secondary">
                            <span class="sr-only">${$headerSlider.data("prev-arrow-label")}</span>
                        </button>`,
            nextArrow: `<button type="button" class="slick-next-secondary">
                            <span class="sr-only">${$headerSlider.data("next-arrow-label")}</span>
                        </button>`,
            autoplay: true,
            autoplaySpeed: speed,
            pauseOnFocus: false
        });
    }
};

export default function () {
    initHeaderCarousel();
}
